import React from "react"

import {
	Box,
	Button,
	Grid,
	Paper,
	Typography,
} from "@mui/material"

import { UseFormReturn } from "react-hook-form"

import {
	MatesSelect,
	MatesTextField,
	withUseFormHook,
} from "@sinossi/mates-react-library"

import {
	PageHeader,
	PageSectionTitle,
	RoutesData,
} from "components/commons"

import AffiliatesSearchSchema, { AffiliatesSearchForm } from "./form"
import { AffiliatesTable } from "components/affiliates/affiliates-table/affiliates-table"
import {
	GoogleMap,
	LoadScript,
	Marker,
} from "@react-google-maps/api"

interface AffiliatesProps extends UseFormReturn
{
}
interface AffiliatesState
{
	entries: any[]|null
	selected: any
	mapInitialised: boolean
}
class Affiliates extends React.Component<AffiliatesProps, AffiliatesState>
{
	private mapRef: any = React.createRef()

	private readonly entries: Record<string, any> = {
		"Cagliari": [
			{
				"id": "01H95XD2MZPP0NJHB72NVVJSW7",
				"name": "Old Wild West",
				"products": [
					{
						"id": "01H95XD3XAB0Y5QVQP8YPDKMWX",
						"name": "Griglieria, Steak House",
					},
					{
						"id": "01H95XD3XJD86AH3DW7AF6H9QY",
						"name": "Ristorante, Pizzeria",
					},
				],
				"city": "Cagliari",
				"assetCount": 2,
				"coordinates": [
					[39.22769788466317, 9.09686538301123],
					[39.245663463974005, 9.16244825651674],
				],
			},
			{
				"id": "01H95XD1MWAX7JBPTWZ277J6H9",
				"name": "Mc Donald's",
				"products": [
					{
						"id": "01H95XD3XTNJX4DQ6NHHB03DQS",
						"name": "Paninoteca, Burgeria",
					},
				],
				"city": "Cagliari",
				"assetCount": 7,
				"coordinates": [
					[39.217591468077366, 9.113287127819687],
					[39.232578198693616, 9.092029455394366],
					[39.229083555517526, 9.120474973898054],
					[39.25152916376212, 9.112598929796226],
					[39.25499041159521, 9.061548778278185],
					[39.245891611067314, 9.164754784741014],
					[39.23008363744031, 9.216136397971793],
				],
			},
			{
				"id": "01H95XD25ECJ321RDK07FNW20M",
				"name": "La Piadineria",
				"products": [
					{
						"id": "01H95XD3XTNJX4DQ6NHHB03DQS",
						"name": "Paninoteca, Burgeria",
					},
				],
				"city": "Cagliari",
				"assetCount": 3,
				"coordinates": [
					[39.23248351624982, 9.09178075731399],
					[39.217042721286454, 9.118885013789498],
					[39.245762298336246, 9.164840624776822],
				],
			},
		],
		"Sassari": [
			{
				"id": "01H95XD1MWAX7JBPTWZ277J6H9",
				"name": "Mc Donald's",
				"products": [
					{
						"id": "01H95XD3XTNJX4DQ6NHHB03DQS",
						"name": "Paninoteca, Burgeria",
					},
				],
				"city": "Sassari",
				"assetCount": 2,
				"coordinates": [
					[40.73986543146327, 8.534685908171772],
					[40.727465729378096, 8.549367466109159],
				],
			},
		],
		"Milano": [
			{
				"id": "01H95XD1Q0HNMMN2QDNMYGSP4G",
				"name": "Kfc",
				"products": [
					{
						"id": "01H95XD3XAB0Y5QVQP8YPDKMWX",
						"name": "Griglieria, Steak House",
					},
					{
						"id": "01H95XD3XJD86AH3DW7AF6H9QY",
						"name": "Ristorante, Pizzeria",
					},
				],
				"city": "Milano",
				"assetCount": 2,
				"coordinates": [
					[45.571743861809615, 9.054263199192947],
					[45.38707006120687, 9.311298153392872],
				],
			},
			{
				"id": "01H95XD1VT8N013Y1PETXSRRSN",
				"name": "Road House",
				"products": [
					{
						"id": "01H95XD3XAB0Y5QVQP8YPDKMWX",
						"name": "Griglieria, Steak House",
					},
					{
						"id": "01H95XD3XJD86AH3DW7AF6H9QY",
						"name": "Ristorante, Pizzeria",
					},
				],
				"city": "Milano",
				"assetCount": 2,
				"coordinates": [
					[45.46628099076461, 9.196373772244817],
					[45.46698276911784, 9.198375066343447],
				],
			},
			{
				"id": "01H95XD25ECJ321RDK07FNW20M",
				"name": "La Piadineria",
				"products": [
					{
						"id": "01H95XD3XTNJX4DQ6NHHB03DQS",
						"name": "Paninoteca, Burgeria",
					},
				],
				"city": "Milano",
				"assetCount": 19,
				"coordinates": [
					[45.43753654159592, 9.089164751734783],
					[45.455003964085904, 9.163295179909115],
					[45.45342817803169, 9.192685273907523],
					[45.459993662775965, 9.184822955767823],
					[45.462619642634934, 9.193059670009415],
					[45.4627509384173, 9.204291553066131],
					[45.464589047264774, 9.208784306288818],
					[45.464589047264774, 9.18369976746215],
					[45.46760866740966, 9.195680442722647],
					[45.46629580896076, 9.177896627882847],
					[45.46760866740966, 9.152437692954289],
					[45.47522264343943, 9.194557254416978],
					[45.478241693939566, 9.156930446176975],
					[45.48086682376454, 9.185946144073494],
					[45.48559174923774, 9.159364020839265],
					[45.490316278439565, 9.194182858315086],
					[45.48742911323729, 9.215149040020957],
					[45.499239307973326, 9.111254121746327],
					[45.51314591662608, 9.18650773822633],
				],
			},
			{
				"id": "01H95XD166TM4YGW5KP0KXE2X1",
				"name": "Burger King",
				"products": [
					{
						"id": "01H95XD3XTNJX4DQ6NHHB03DQS",
						"name": "Paninoteca, Burgeria",
					},
				],
				"city": "Milano",
				"assetCount": 8,
				"coordinates": [
					[45.44947541315248, 9.139788729862266],
					[45.44529573960946, 9.178971744415099],
					[45.47735876741056, 9.144142398145913],
					[45.498081544517646, 9.175649208093368],
					[45.490210999983326, 9.19478243449782],
					[45.486516283422844, 9.205666605206941],
					[45.486516283422844, 9.217696478095968],
					[45.492781094654475, 9.225830963573312],
				],
			},
		],
	}

	constructor(props: AffiliatesProps)
	{
		super(props)
		this.state = {
			entries: null,
			selected: null,
			mapInitialised: false,
		}
	}

	private searchAffiliates = (data: any): void => {
		const form = new AffiliatesSearchForm()
		Object.assign(form, data)

		const city: string = form.city ?? ""
		const entries: any = this.entries[city] ?? []

		this.setState(() => ({
			selected: null,
			mapInitialised: false,
			entries: entries,
		}))
	}

	private onEnterPressedInForm = (event: any) => {
		if(event.key !== "Enter") {
			return
		}
		if(!this.props.formState.isValid) {
			return
		}

		const data = this.props.getValues()
		this.searchAffiliates(data)
	}

	private getMapBounds = (): google.maps.LatLngBounds => {
		const bounds = new google.maps.LatLngBounds();

		this.state.selected.coordinates.forEach((location: number[]) => {
			bounds.extend(new google.maps.LatLng(location[0], location[1]))
		})

		return bounds
	}

	private onSelectionChanged = (id: string): void => {
		const entry = this.state.entries?.find(it => it.id === id)
		this.setState(
			() => ({ selected: entry, }),
			() => {
				if(!this.state.mapInitialised) {
					return
				}

				const bounds = this.getMapBounds()
				this.mapRef.fitBounds(bounds)
			}
		)
	}

	render()
	{
		const { isValid } = this.props.formState

		return (
			<Box sx={{ width: '100%', pt: 2, position: "relative" }}>
				<PageHeader
					title={RoutesData.AFFILIATES.title}
					paths={[ RoutesData.DASHBOARD, RoutesData.AFFILIATES ]}
				/>

				<Grid
					container
					sx={(theme) => ({
						p: 2,
						width: "55%",
						mx: "auto",
						mt: 5,
						backgroundColor: theme.palette.background.default,
					})}
					spacing={2}>
					<Grid item xs={6}>
						<MatesSelect
							name="city"
							label="Città"
							variant="outlined"
							formState={this.props.formState}
							control={this.props.control}
							trigger={this.props.trigger}>
							<option value="Cagliari">Cagliari</option>
							<option value="Milano">Milano</option>
							<option value="Sassari">Sassari</option>
						</MatesSelect>
					</Grid>
					<Grid item xs={6}>
						<MatesSelect
							name="category"
							label="Categoria"
							variant="outlined"
							formState={this.props.formState}
							control={this.props.control}
							trigger={this.props.trigger}>
							<option value="01H95XD3XJD86AH3DW7AF6H9QY">Ristorante, Pizzeria</option>
						</MatesSelect>
					</Grid>

					<Grid item xs textAlign="center">
						<Button
							type="button"
							variant="contained"
							disabled={!isValid}
							onClick={this.props.handleSubmit(this.searchAffiliates)}
						>Cerca</Button>
					</Grid>
				</Grid>

				{this.state.entries !== null &&
					<Box sx={{ mt: 3 }}>
						<PageSectionTitle title={RoutesData.AFFILIATES.title} />
						<AffiliatesTable
							data={this.state.entries}
							onSelectionChanged={this.onSelectionChanged}
						/>
					</Box>
				}
				{this.state.selected !== null &&
					<Paper sx={{
						mt: 3,
						p: 2,
					}} elevation={0}>
						<Typography fontSize={16} fontWeight="light" mb={2}>
							{this.state.selected.coordinates.length} risultati per {this.state.selected.name}
						</Typography>

						<Box style={{
							height: "400px",
							width: "100%",
						}}>
							<LoadScript googleMapsApiKey="AIzaSyCJiclrDzpvGD3bqTSp3NHlB4wQ7j-b1XQ">
								<GoogleMap
									id="map-home"
									mapContainerStyle={{
										height: "100%",
										width: "100%",
									}}
									center={{
										lat: 39.217042721286454,
										lng: 9.118885013789498,
									}}
									zoom={13}
									ref={this.mapRef}
									onLoad={(map) => {
										this.mapRef = map

										const bounds = this.getMapBounds()
										map.fitBounds(bounds)

										this.setState(() => ({ mapInitialised: true, }))
									}}
								>
									{this.state.selected.coordinates
										.map((it: number[]) => (
											<Marker
												position={{
													lat: it[0],
													lng: it[1],
												}}></Marker>
										))
									}
								</GoogleMap>
							</LoadScript>
						</Box>
					</Paper>
				}
			</Box>
		)
	}
}

export default withUseFormHook<AffiliatesSearchForm>(
	Affiliates,
	AffiliatesSearchSchema,
	new AffiliatesSearchForm(),
)
